
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Waterfall/index.md?watch=parent';
    export const demoIndex = {
  ids: ["waterfall-demo-common","waterfall-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__Waterfall" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Waterfall/index.md?type=demo')
};